import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import client from "../lib/api";
import { useSeo } from "../lib/useSeo";
import Layout, { Spinner } from "../components/Layout";
import { NewsCard } from "../components/NewsCard";

const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const fmtMonth = (m) => { const [y, mo] = m.split("-"); return `${MONTH_NAMES[parseInt(mo, 10) - 1]} ${y}`; };

export default function Archive() {
  const [months, setMonths] = useState(null);
  const [params, setParams] = useSearchParams();
  const active = params.get("month");
  const [items, setItems] = useState(null);
  useSeo({ title: "News Archive", description: "Browse Rapid24News archive — six months of Lucknow, Uttar Pradesh, India and World news by month." });

  useEffect(() => { client.get("/archive").then((r) => { setMonths(r.data.months); if (!active && r.data.months[0]) setParams({ month: r.data.months[0].month }); }); }, []);
  useEffect(() => { if (!active) return; setItems(null); client.get("/articles", { params: { month: active, limit: 40 } }).then((r) => setItems(r.data.items)); }, [active]);

  return (
    <Layout>
      <div className="bg-r24-black text-white">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <h1 className="font-head font-bold text-4xl md:text-5xl uc">News <span className="text-r24-red">Archive</span></h1>
          <p className="text-gray-400 mt-1">Six months of Rapid24News — browse by month</p>
        </div>
      </div>
      <section className="max-w-7xl mx-auto px-4 py-8">
        {!months ? <Spinner /> : (
          <div className="flex flex-wrap gap-2 mb-8" data-testid="archive-months">
            {months.map((m) => (
              <button key={m.month} onClick={() => setParams({ month: m.month })} data-testid={`archive-month-${m.month}`}
                className={`font-head font-bold uc text-sm px-4 py-2 border-2 ${active === m.month ? "bg-r24-red border-r24-red text-white" : "border-black hover:bg-black hover:text-white"}`}>
                {fmtMonth(m.month)} <span className="opacity-60">({m.count})</span>
              </button>
            ))}
          </div>
        )}
        {items === null ? <Spinner /> : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-8" data-testid="archive-grid">
            {items.map((a) => <NewsCard key={a.slug} a={a} />)}
          </div>
        )}
      </section>
    </Layout>
  );
}
